/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { humanize } from "uno-js";
import { toast } from "react-hot-toast";
import { ADDITIONAL_INFO_REQUIRED } from "../pages/OcApplicationDetails/graphql/additionalInfo.mutation";
import { string } from "yup";

const MODULE_NAME = "AdditionalInfoService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class AdditionalInfoService {
    private static instance: AdditionalInfoService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL;
    }
    public static getInstance(props: any = {}): AdditionalInfoService {
        if (!AdditionalInfoService.instance) {
            AdditionalInfoService.instance = new AdditionalInfoService(props);
        }
        return AdditionalInfoService.instance;
    }

    async additionalInfo(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `additional info data in service`, data);
        console.log("additionalInfo:", data);

        try {
            if (client) {
                const res = await client.mutate({
                    mutation: ADDITIONAL_INFO_REQUIRED,
                    variables: {
                        applicationId: data?.applicationId,
                        reason: data?.reason,
                    },
                    fetchPolicy: "no-cache",
                });

                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
